import { Box, ListItem, Typography } from '@mui/material'
import TruncatedText from './TruncatedText'
import { ReactElement } from 'react'

interface ViewEntityBoxProps {
    index: number
    name: string
    textValue: React.ReactNode
}

const ViewEntityBox = ({
    index,
    name,
    textValue,
}: ViewEntityBoxProps): ReactElement => {
    return (
        <ListItem
            key={index}
            sx={{
                alignItems: 'flex-start',
                paddingLeft: '0px',
                paddingRight: '0px',
            }}
        >
            <Box sx={{ width: '40%' }}>
                <TruncatedText
                    sx={{
                        fontSize: '14px',
                        fontWeight: '600',
                    }}
                    text={name}
                />
            </Box>
            <Box>
                <Typography
                    sx={{
                        marginRight: '10px',
                        marginLeft: '10px',
                        fontSize: '14px',
                        fontWeight: '600',
                    }}
                >
                    :
                </Typography>
            </Box>
            <Box sx={{ maxWidth: 'calc(60% - 25px)' }} id={name}>
                {textValue}
            </Box>
        </ListItem>
    )
}

export default ViewEntityBox
